import { render, staticRenderFns } from "./DownloadRules.vue?vue&type=template&id=fd506c36&scoped=true&"
import script from "./DownloadRules.vue?vue&type=script&lang=js&"
export * from "./DownloadRules.vue?vue&type=script&lang=js&"
import style0 from "./DownloadRules.vue?vue&type=style&index=0&id=fd506c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd506c36",
  null
  
)

export default component.exports